/* eslint-disable import/no-cycle */
/* eslint-disable no-bitwise */
import { random } from 'lodash';
import { v4 as uuid } from 'uuid';
import {
  IMAGE_TYPES, VIDEO_TYPES, FILE_TYPES,
} from '$/utils/upload';
import { message } from '$/components/Message';
import { useOfficialStore } from '$/store/useOfficialStore';

export const getFileKeysInfo = (count: number, { type, prefix, suffix }: { type?: string; prefix?: string; suffix?: string; }) => {
  const result = [];
  for (let i = 0; i < count; i += 1) {
    const fileKey = `${Date.now()}_${random(10000000, 99999999)}`;
    result.push({
      fileKey: `${prefix}${fileKey}`,
      uri: `${type || 'images'}/${prefix}${fileKey}.${suffix}`,
    });
  }
  return result;
};

/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-22 15:12:23
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-05-22 15:13:03
 * @FilePath: /roboneo-web/src/utils/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export interface ImageSize {
  width: number;
  height: number;
  base64: string;
}

/**
 * 通过file对象获取图片宽高
 *
 * @export
 * @param {File} file
 * @return {*}  {Promise<ImageSize>}
 */
export function getImgSizeByFile(file: File): Promise<ImageSize> {
  return new Promise((resolve, reject) => {
    let base64 = '';
    const img = new Image();
    img.onload = () => {
      console.log('width', img.naturalWidth, 'height', img.naturalHeight);
      resolve({
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height,
        base64,
      });
    };

    img.onerror = () => {
      resolve({
        width: 0,
        height: 0,
        base64: '',
      });
    };

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      base64 = reader.result as string;
      img.src = reader.result as string;
    };
    reader.onerror = reject;
  });
}

/**
 * 获取图片信息
 * @param url 图片地址
 * @returns 图片信息（宽高等）
 */
export async function getImageElementByURL(url: string) {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = url;
    image.onload = () => {
      resolve(image);
    };
    image.onerror = () => {
      reject();
    };
  });
}

/**
 * 获取视频信息
 * @param url 视频地址（可以是 blob URL、远程地址等）
 * @returns 包含视频宽高的 HTMLVideoElement
 */
export function getVideoElementByURL(url: string): Promise<HTMLVideoElement> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.src = url;
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      resolve(video);
    };

    video.onerror = (err) => {
      reject(new Error('Failed to load video metadata'));
    };
  });
}

// 获取视频封面宽高
interface VideoInfo {
  width: number;
  height: number;
  duration: number;
  firstFrameUrl: string;
}

/**
 * 通过file对象获取视频封面宽高
 *
 * @export
 * @param {File} file
 * @return {*}  {Promise<VideoInfo>}
 */
export function getVideoCoverSizeByFile(file: File): Promise<VideoInfo> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      const info: VideoInfo = {
        width: video.videoWidth,
        height: video.videoHeight,
        duration: video.duration,
        firstFrameUrl: URL.createObjectURL(file),
      };

      // 清理资源
      URL.revokeObjectURL(video.src);
      resolve(info);
    };

    video.onerror = () => {
      URL.revokeObjectURL(video.src);
      reject(new Error('无法加载视频'));
    };

    video.src = URL.createObjectURL(file);
  });
}

/**
 * 生成uuid
 * @export
 * @return {*}
 */
export function generateUUID() {
  return uuid();
}

/**
 * 判断是否为windows系统
 *
 * @export
 * @return {*}
 */
export function isWindows() {
  return navigator.userAgent.includes('Windows');
}

/**
 * 替换模板中的 {xxx} 占位符
 * @param template - 字符串模板
 * @param params - 替换参数
 */
export function replaceTemplateParams(template: string, params?: Record<string, any>): string {
  if (!params) return template;

  return template.replace(/\{(\w+)\}/g, (_, key) => {
    return params[key] ?? '';
  });
}

/**
 * 获取当前设备类型
 *
 * @returns 是否是安卓系统
 */
export function checkIsAndroid() {
  const { userAgent } = navigator;
  let isAndroid = false;
  if (userAgent.indexOf('android') >= 0 || userAgent.indexOf('Android') >= 0 || userAgent.indexOf('Linux') >= 0) {
    isAndroid = true;
  } else {
    isAndroid = false;
  }
  return isAndroid;
}

/**
 * 判断 URL 是否是图片链接，并返回图片后缀（如 "png"、"jpg"）
 * @param url 要检查的 URL
 * @returns { extension: string | null, isImage: boolean }
 */
export function getImageExtensionFromUrl(url: string): { extension: string | null; isImage: boolean; } {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname.toLowerCase();

    // 匹配常见的图片后缀（可自行扩展）
    const match = pathname.match(/\.(png|jpe?g|gif|webp|svg|bmp|ico|tiff?)$/i);

    if (match) {
      return { extension: match[1], isImage: true }; // 返回小写的扩展名（如 "png"）
    }
    return { extension: null, isImage: false };
  } catch (err) {
    return { extension: null, isImage: false }; // 无效的 URL
  }
}

// 在 utils 中添加
export function checkIsWeChat() {
  return /MicroMessenger/i.test(navigator.userAgent);
}

/**
 * 判断是否为移动端
 *
 * @export
 * @param {string} [userAgent]
 * @return {*}
 */
export function isMobile() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipod|android.*mobile|mobile|windows phone|micromessenger/i.test(ua);
}

/**
 * key为string类型的Map转对象
 *
 * @export
 * @param {Map<string, unknown>} strMap
 * @return {*}
 */
export function strMapToObj(strMap: Map<string, unknown>) {
  const obj = Object.create(null);
  for (const [k, v] of strMap) {
    obj[k] = v;
  }
  return obj;
}

/**
 * 获取 URL 参数（返回 URLSearchParams 实例，兼容普通 query 和 hash query）
 * @param {string} [url=window.location.href] 可选 URL，不传默认用当前页面
 * @returns {URLSearchParams} URLSearchParams 实例
 */
export function getUrlSearchParams(url = window.location.href) {
  try {
    const u = new URL(url);

    // 合并普通 query 和 hash query
    const combinedParams = new URLSearchParams(u.search);

    const hash = u.hash || ''; // e.g., "#/share?short_link=lLUD6J2oiagVm&theme=dark"
    if (hash.includes('?')) {
      const hashQuery = hash.substring(hash.indexOf('?') + 1);
      const hashParams = new URLSearchParams(hashQuery);
      for (const [key, value] of hashParams.entries()) {
        combinedParams.set(key, value); // hash 参数覆盖普通参数
      }
    }

    return combinedParams;
  } catch (e) {
    console.error('无效 URL', e);
    return new URLSearchParams(); // 返回空实例，避免报错
  }
}

/**
 * 拖拽上传媒体资源到agent输入框校验
 *
 * @export
 * @param {File[]} files 待上传的文件列表
 * @param {object} mediaCounts 当前输入框中各类型媒体数量
 * @param {object} limits 媒体数量限制配置
 * @param {object} options 校验行为开关，默认按类型独立限制
 * @return {*}
 */
export function dropInputFileValid(
  files: File[],
  mediaCounts: { imageCount: number; videoCount: number; documentCount: number; },
  limits: { maxImageNum: number; maxVideoNum: number; maxDocumentNum: number; },
  options: { checkCombinedLimit?: boolean; } = {},
) {
  const { imageCount, videoCount, documentCount } = mediaCounts;
  const MAX_AGENT_IMAGE_NUMS = limits.maxImageNum;
  const MAX_AGENT_VIDEO_NUMS = limits.maxVideoNum;
  const MAX_AGENT_DOCUMENT_NUMS = limits.maxDocumentNum;
  const { checkCombinedLimit = false } = options;

  const mediaType: ('image' | 'video' | 'file')[] = [];
  files.forEach((file) => {
    if (!mediaType.includes('image') && IMAGE_TYPES.includes(file.type)) {
      mediaType.push('image');
    }
    if (!mediaType.includes('video') && VIDEO_TYPES.includes(file.type)) {
      mediaType.push('video');
    }
    if (!mediaType.includes('file') && FILE_TYPES.includes(file.type)) {
      mediaType.push('file');
    }
  });

  const maxMixedImage = MAX_AGENT_IMAGE_NUMS - MAX_AGENT_VIDEO_NUMS - MAX_AGENT_DOCUMENT_NUMS;
  const hasIncomingOtherMedia = mediaType.includes('video') || mediaType.includes('file');
  const hasOtherMedia = checkCombinedLimit && (videoCount > 0 || documentCount > 0 || hasIncomingOtherMedia);
  const effectiveImageMax = hasOtherMedia ? maxMixedImage : MAX_AGENT_IMAGE_NUMS;
  let videoImportCount = MAX_AGENT_VIDEO_NUMS - videoCount;
  let documentImportCount = MAX_AGENT_DOCUMENT_NUMS - documentCount;
  if (checkCombinedLimit && imageCount > maxMixedImage) {
    videoImportCount = 0;
    documentImportCount = 0;
  }
  if (videoCount >= MAX_AGENT_VIDEO_NUMS) {
    videoImportCount = 0;
  }
  if (documentCount >= MAX_AGENT_DOCUMENT_NUMS) {
    documentImportCount = 0;
  }
  const controlFileParams = {
    controlImagesOptions: {
      importCount: Math.max(0, effectiveImageMax - imageCount),
      maxTotal: effectiveImageMax,
      currentVideoCount: checkCombinedLimit ? videoCount : 0,
    },
    controlVideosOptions: {
      importCount: Math.max(0, videoImportCount),
    },
    controlFilesOptions: {
      importCount: Math.max(0, documentImportCount),
    },
    controlAudiosOptions: {
      importCount: Math.max(0, documentImportCount),
    },
  };

  // 混合模式限制：有视频/文件时图片上限为 maxMixedImage
  if (checkCombinedLimit
    && (videoCount > 0 || documentCount > 0 || mediaType.includes('video') || mediaType.includes('file'))
    && imageCount > maxMixedImage) {
    message.info({
      content: {
        key: 'roboneo_chat_resources_num_limit_tips',
        params: {
          img_num: maxMixedImage,
          video_num: MAX_AGENT_VIDEO_NUMS,
        },
      },
    });
    return {
      mediaType,
      controlFileParams,
      valid: false,
    };
  }

  const leftImageNum = MAX_AGENT_IMAGE_NUMS - imageCount;
  const leftVideoNum = MAX_AGENT_VIDEO_NUMS - videoCount;
  const leftDocumentNum = MAX_AGENT_DOCUMENT_NUMS - documentCount;

  // 如果不支持上传视频不进行提示
  if (!MAX_AGENT_VIDEO_NUMS && mediaType.includes('video')) {
    return {
      mediaType,
      controlFileParams,
      valid: false,
    };
  }

  // 超过视频最大数量
  if (leftVideoNum === 0 && mediaType.includes('video')) {
    message.info({
      content: {
        key: 'RoboNeo_Web_upload_video_maximum',
        params: {
          max_num: MAX_AGENT_VIDEO_NUMS,
        },
      },
    });
    return {
      mediaType,
      controlFileParams,
      valid: false,
    };
  }
  // 超过图片最大数量
  if (leftImageNum === 0 && mediaType.includes('image')) {
    message.info({
      content: {
        key: 'RoboNeo_Web_upload_image_maximum',
        params: {
          max_num: MAX_AGENT_IMAGE_NUMS,
        },
      },
    });
    return {
      mediaType,
      controlFileParams,
      valid: false,
    };
  }
  if (leftDocumentNum === 0 && mediaType.includes('file')) {
    message.info({
      content: {
        key: 'roboneo_file_limit',
      },
    });
    return {
      mediaType,
      controlFileParams,
      valid: false,
    };
  }

  return {
    mediaType,
    controlFileParams,
    valid: true,
  };
}

/**
 * 获取谷歌投放设备id
 *
 * @export
 * @return {*}
 */
export function getGoogleClientId() {
  try {
    return new Promise<string>((resolve) => {
      const target_id = useOfficialStore.getState().google_target_id;
      if (!target_id) {
        resolve('');
        return;
      }

      const gtag = (window as any).gtag as undefined | ((...args: any[]) => void);
      if (typeof gtag !== 'function') {
        resolve('');
        return;
      }

      let settled = false;
      const safeResolve = (val: unknown) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(typeof val === 'string' ? val : '');
      };

      // 某些浏览器/环境下 gtag 的回调可能永远不触发，避免 Promise 一直 pending
      const timer = window.setTimeout(() => safeResolve(''), 1500);
      gtag('get', target_id, 'client_id', safeResolve);
    });
  }
  catch (error) {
    console.error('Failed to get google client id:', error);
    return Promise.resolve('');
  }
}

/**
 * 获取谷歌 gclid
 *
 * @export
 * @return {*}
 */
export function getGclid() {
  try {
    return new Promise<string>((resolve) => {
      const target_id = useOfficialStore.getState().google_target_id;
      if (!target_id) {
        resolve('');
        return;
      }

      const gtag = (window as any).gtag as undefined | ((...args: any[]) => void);
      if (typeof gtag !== 'function') {
        resolve('');
        return;
      }

      let settled = false;
      const safeResolve = (val: unknown) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(typeof val === 'string' ? val : '');
      };

      const timer = window.setTimeout(() => safeResolve(''), 1500);
      gtag('get', target_id, 'gclid', safeResolve);
    });
  }
  catch (error) {
    console.error('Failed to get gclid:', error);
    return Promise.resolve('');
  }
}

export interface AVinfo {
  size: number;
  duration: number;
  width: number;
  height: number;
}

type AvinfoVideoStreamSideData = {
  rotation?: number;
  side_data_type?: string;
};

type AvinfoVideoStream = {
  width?: number;
  height?: number;
  /** ffprobe 形如 "9:16"、"1:1"；非 1:1 时需换算为与播放器一致的方形像素显示宽高 */
  sample_aspect_ratio?: string;
  side_data_list?: AvinfoVideoStreamSideData[];
};

/**
 * 解析 ffprobe / avinfo 中的比例字符串（如 sample_aspect_ratio）。
 *
 * @param ratio - 宽比高形式的字符串，或缺失/非法
 * @returns 分子分母，无法解析或非正数时返回 undefined
 */
function parseFfprobeRatioString(ratio: string | undefined): ({ num: number; den: number; } | undefined) {
  if (!ratio || ratio === 'N/A' || ratio === '0:1') {
    return undefined;
  }
  const parts = ratio.split(':').map((s) => Number(s.trim()));
  if (parts.length !== 2 || parts.some((n) => !Number.isFinite(n) || n <= 0)) {
    return undefined;
  }
  return { num: parts[0], den: parts[1] };
}

/**
 * 将角度归一化到 [0, 359] 整数，用于判断是否与显示矩阵旋转一致。
 *
 * @param rotation - ffprobe side_data 中的 rotation（度）
 * @returns 归一化后的角度
 */
function normalizeVideoRotationDegrees(rotation: number): number {
  return ((Math.round(rotation) % 360) + 360) % 360;
}

/**
 * 根据编码宽高、sample_aspect_ratio 与 rotation 计算与浏览器解码显示一致的宽高。
 * SAR 非 1:1 时按 FFmpeg 常见规则将宽度缩放为 round(width * num / den)（与 720×720 + SAR 9:16 → 405×720 一致）。
 * rotation 为 90° 或 270° 时在 SAR 之后再对调宽高。
 *
 * @param stream - avinfo / ffprobe 返回的视频 stream（通常为 streams[0]）
 * @returns 显示用的 width、height
 */
function getVideoDisplayDimensionsFromStream(stream: AvinfoVideoStream | undefined): {
  width: number;
  height: number;
} {
  let w = Number(stream?.width) || 0;
  const h = Number(stream?.height) || 0;
  const sar = parseFfprobeRatioString(stream?.sample_aspect_ratio);
  if (sar && sar.num !== sar.den) {
    w = Math.round((w * sar.num) / sar.den);
  }
  let rotationDeg: number | undefined;
  const list = stream?.side_data_list;
  if (Array.isArray(list)) {
    for (const item of list) {
      if (item && typeof item.rotation === 'number' && !Number.isNaN(item.rotation)) {
        rotationDeg = item.rotation;
        break;
      }
    }
  }
  if (rotationDeg === undefined) {
    return { width: w, height: h };
  }
  const r = normalizeVideoRotationDegrees(rotationDeg);
  if (r === 90 || r === 270) {
    return { width: h, height: w };
  }
  return { width: w, height: h };
}

/**
 * 基于云函数，获取视频信息
 *
 * @export
 * @param {string} videoUrl
 * @return {*}  {Promise<{ vaInfo: AVinfo; rawInfo: any; }>}
 */
export async function getAVinfo(videoUrl: string): Promise<{ vaInfo: AVinfo; rawInfo: any; }> {
  const url = videoUrl.includes('?') ? `${videoUrl}&avinfo` : `${videoUrl}?avinfo`;
  const rawInfo = await fetch(url).then((res) => res.json());
  const videoStream = rawInfo?.streams?.[0] as AvinfoVideoStream | undefined;
  const { width, height } = getVideoDisplayDimensionsFromStream(videoStream);
  return {
    vaInfo: {
      size: rawInfo.format.size,
      duration: isNaN(Number(rawInfo.format.duration)) ? 0 : Math.ceil(Number(rawInfo.format.duration)),
      width,
      height,
    },
    rawInfo,
  };
}

export * from './previewInlineVideoRegistry';
export * from './previewInlineVideoHandoff';
